////////////////////////////////////////////////////////////////////////////////
//
//
// (C) Copyright 2023 Autodesk, Inc. All rights reserved.
//
//                      ****  CONFIDENTIAL MATERIAL  ****
//
// The information contained herein is confidential, proprietary to
// Autodesk, Inc., and considered a trade secret.  Use of this information
// by anyone other than authorized employees of Autodesk, Inc. is granted
// only under a written nondisclosure agreement, expressly prescribing the
// the scope and manner of such use.
//
////////////////////////////////////////////////////////////////////////////////

import {RevitVersion} from '../clients/Classes';
import {uniqueFilter} from "../Utility";

export class ConvertRevitVersion {
  static minimumSupportedRevitVersion = 2021;

  public static Convert(value: RevitVersion | undefined): string {
    return value?.includes('V')
      ? value.replace('V', '')
      : 'Auto';
  }

  public static GetNonDeprecatedVersions(): RevitVersion[] {
    return Object.values(RevitVersion)
      .filter(x => x === RevitVersion.Auto || +this.Convert(x) >= this.minimumSupportedRevitVersion)
      .filter(uniqueFilter);
  }
}